export const DEFAULT_PATH_COST_CONFIG = {
  justification: "L",
  locales: "es-ES",
  currency: true,
  currencyIndicator: "EUR",
  percentage: false,
  precision: 0,
  wholenumber: null,
  commafy: true,
  shortFormat: true,
  shortFormatMinValue: 10000,
  title: true
};
// eslint-disable-next-line
export const SET_WEIGHT_ABS = "2";
// eslint-disable-next-line
export const SET_WEIGHT_REL = "1";
// eslint-disable-next-line
export const SET_WEIGHT_NOWEIGHT = "3";
// eslint-disable-next-line
export const MAX_CAT_WEIGHT_NOWEIGHT = 1;
// eslint-disable-next-line
export const MAX_CAT_WEIGHT_ABS = 1000;
// eslint-disable-next-line
export const MAX_CAT_WEIGHT_REL = 100;
// eslint-disable-next-line
export const BUFFER_LAYER_SIGNAL_HIDE = 2;
// eslint-disable-next-line
export const BUFFER_LAYER_SIGNAL_SHOW = 1;
// eslint-disable-next-line
export const COMPLETE_SIGNAL = 0;
// eslint-disable-next-line
export const COLORS_UI = [
  "#FF2D55",
  "#242E45",
  "#00BEF3",
  "#FFCC00",
  "#4CD964"
];
// eslint-disable-next-line
export const COLORS_UI_LIGHTER = [
  "#FF5470",
  "#454D61",
  "#49C8F6",
  "#FFD447",
  "#6EDF7D"
];
// eslint-disable-next-line
export const COLORS_UI_HIGHLIGHTS = [
  "#C5EDFB",
  "#FFF9E5",
  "#EBFBEE",
  "#FFE8EC",
  "#F1E2FE",
  "#FFEEE0"
];
// eslint-disable-next-line
export const COLORS_UI_HIGHLIGHTS_DARKER = [
  "#ADC4CA",
  "#CCC6B2",
  "#B8C8BB",
  "#CCB5B9",
  "#BEAFCB",
  "#CCBBAD"
];

export const DEFAULT_COLOR = "rgba(18, 153, 236, 0.5)";
export const DEFAULT_OPACITY = 0.7;

// Technology dropdown
export const TECHNOLOGY_DROPDOWN_NO_AVAILABLE_OPTION_ID = -1;

// Open Layers
// Layers
export const AREA_SOURCE = "AreaSource";
export const START_POINT_SOURCE = "StartPointSource";
export const END_POINT_SOURCE = "EndPointSource";
export const INTERMEDIATE_POINTS_SOURCE = "IntermediatePointsSource";
export const AUX_INTERMEDIATE_POINTS_SOURCE = "AuxIntermediatePointsSource";
export const STREET_VIEW_POINT_SOURCE = "StreetViewPointSource";
export const HIGHLIGHTED_POINTS_SOURCE = "HighlightedPointsSource";
export const COMMENTS_SOURCE = "CommentsSource";
export const COMMENTS_CLUSTER_SOURCE = "CommentsClusterSource";

// Collections
export const VECTOR_LAYERS_COLLECTION = "VectorLayersCollection";
export const RASTER_LAYERS_COLLECTION = "RasterLayersCollection";
export const RESISTANCE_MAPS_COLLECTION = "ResistanceMapsCollection";
export const CORRIDORS_COLLECTION = "CorridorsCollection";
export const COMPARISION_MAPS_COLLECTION = "CmparisionMapsCollection";
export const EDITABLE_BASELAYERS_COLLECTION = "EditableBaselayersCollection";
export const PATHS_COLLECTION = "PathsCollection";
export const VECTOR_GEOPROCESSES_COLLECTION = "VectorGeoprocessesCollection";
export const RASTER_GEOPROCESSES_COLLECTION = "RasterGeoprocessesCollection";
export const SITES_COLLECTION = "SitesCollection";

// Cesium Constants
export const projectVectorName = "ProjectsVector";
export const optimalPathVectorName = "optimalPathVector";
export const intermediatePointName = "IntermediatePoints";
export const startPointScenarioName = "StartPointScenario";
export const startPointProjectName = "startPointProject";
export const endPointScenarioName = "EndPointScenario";
export const endPointProjectName = "endPointProject";
export const towerName = "tower";
export const lineName = "line";
export const corridorLayerName = "SystemLayer CorridorMap";
export const rasterLayerName = "SystemLayer RasterLayer";
export const resistanceLayerName = "SystemLayer ResistanceMap";
export const comparisonMapLayerName = "SystemLayer ComparisonMap";
export const siteLayerName = "SystemLayer SiteMap";
export const CAMERA_MOVEMENT_DEFAULT_FACTOR = 50.0;
export const CAMERA_LOOK_DEFAULT_FACTOR = 0.01;
export const HUMAN_EYE_HEIGHT = 1.65;

//PROGRESS ITEM STATES
// a task that failed
export const FAILURE = "FAILURE";
// a task that finished correctly
export const SUCCESS = "SUCCESS";
// A task that finished correctly but with warning
export const WARNING = "WARNING";
// a task that finished incorrectly
export const ERROR = "ERROR";
// A task acknowledged by the BE, but not yet started
export const QUEUED = "QUEUED";
// We have no information on this task status
export const UNKNOWN = "UNKNOWN";
// A task is pending state
export const PENDING = "PENDING";
// A task is running state
export const RUNNING = "RUNNING";
// A terminated task by user
export const KILLED = "KILLED";
// States after which a task will not make any further progress.
export const FINAL_TASK_STATES = [SUCCESS, FAILURE, WARNING, KILLED, UNKNOWN];

// SINGLE_MULTI_RING
export const SINGLE_RING = 0;
export const MULTI_RING = 1;

export const LAYER_FILTERS = {
  MULTI_RING: "multi-ring",
  SINGLE_RING: "single-ring",
  POLYGON: "polygon",
  LINE: "line",
  POINT: "point",
  RASTER: "raster"
};

export const LAYER_GEOMETRY_TYPES = {
  POINT: "POINT",
  LINE: "LINE",
  POLYGON: "POLYGON",
  RASTER: "RASTER",
  UNKNOWN: "UNKNOWN"
};

// Key codes
export const EnterKey = 13;
export const EscapeKey = 27;
export const ArrowUpKey = 38;
export const ArrowDownKey = 40;
export const F11 = "F11";

// Version and copyright notice
export const PATHFINDER_VERSION = "4.4.5";
export const PATHFINDER_COPYRIGHT = "© 2017-2026 Gilytics AG";

// Scenario settings
export const SCENARIO_SETTINGS_TAB = 2;

// Layer settings
export const EXCESS_RINGS_AMOUNT = 3;

// Backend limit for project layer names.
export const MAX_LAYER_NAME_LENGTH = 100;

// Layer visibility filters
export const LAYER_VISIBILITY_FILTER_ALL = "all";
export const LAYER_VISIBILITY_FILTER_VISIBLE = "visible";
export const LAYER_VISIBILITY_FILTER_HIDDEN = "hidden";

// BaseLayer tab classification
export const BASELAYER_CLASS_RAW_FILE = "BaseLayerRawFile";
export const BASELAYER_CLASS_V2 = "BaseLayerV2";
export const BASELAYER_TAB_UPLOADED = "BaseLayer";
export const BASELAYER_TAB_GILYTICS = "BaseLayerGilytics";
export const BASELAYER_PROVIDER_GILYTICS = "Gilytics";

// Results
export const DEFAULT_CORRIDOR_WIDTH = 10;

export const GEOPROCESS_CATEGORY_NAME = "Geoprocess Output";

// User Types
export const T_SUPERUSER = "superuser";
export const T_ADMIN = "admin";
export const T_USER = "user";
export const T_VIEWER = "viewer";
export const T_DESIGNER = "designer";

// Menu Modes
export const MENU_SUPERUSER = "m_superuser";
export const MENU_ADMIN = "m_admin";
export const MENU_USER = "m_user";
export const MENU_VIEWER = "m_viewer";

/**
 * The short-lived token issued between password check and TFA code entry.
 * Only the two TFA-only endpoints (`/otp/totp/verify/`, `/otp/static/verify/`)
 * accept it; every other endpoint rejects it as a wrong token type.
 * @returns {string|null}
 */
export const getTfaToken = () => sessionStorage.getItem("tfaToken");

/**
 * The session token for all normal authenticated requests.
 *
 * A `tfaToken` left behind by an abandoned TFA screen must NOT shadow a real
 * `appToken` here: the backend answers such a request with
 * "Invalid token type ...", which the FE does not treat as a logout, leaving
 * the user unable to log in (and reload-looping when the token is in
 * localStorage). Callers that genuinely need the TFA token ask for it
 * explicitly via `getTfaToken`.
 * @returns {string|null}
 */
export const getAuthToken = () => {
  return (
    localStorage.getItem("appToken") ||
    sessionStorage.getItem("appToken") ||
    null
  );
};

export const MAX_SCENARIO_NAME = 50;
export const MAX_GEOPROCESS_NAME = 64;

// Used map and data projections
export const EPSG_4326 = "EPSG:4326"; // WGS84
export const EPSG_3857 = "EPSG:3857"; // Spherical Mercator projection for Map, avoids distortion

// Routing Algorithms
export const PATHFINDER_EXPLORE = "GeneticAlgorithm";

// Path metadata
export const EDGE_TYPE_OVERHEAD = "O"; //79; // 'O'
export const EDGE_TYPE_TUNNEL = "T"; // 84; // 'T'
export const EDGE_TYPE_UNDER = "U"; //85; // 'U'

// Cookies
export const COOKIE_CONSENT_DECLINED = "declined";
export const COOKIE_CONSENT_ACCEPTED = "accepted";

// Local Settings
export const LOCAL_SETTINGS_KEY_NAME = "pathfinder-local-settings";
// KeyStore key for persisted geoprocess favorites.
export const FAVORITE_GEOPROCESSES_KEYSTORE_KEY = "favorite_geoprocesess";
// Property name inside the local settings object holding per-scenario
// KPI refresh dialog selections: { [scenarioId]: string[] }.
export const KPI_REFRESH_SELECTION_SETTINGS_KEY = "kpiRefreshSelection";
// Profile > Projects preferred view mode values stored in local settings.
export const PROJECTS_PROFILE_VIEW_MODES = {
  GRID: "grid",
  TABLE: "table"
};

// Profile
export const PROFILE_DATASET_MAX_VISIBLE_PROJECTS = 3;

// Layout
export const DRAWER_DEFAULT_WIDTH = 330;
export const DRAWER_SUBSECTIONS_OPEN_WIDTH = 925;
export const DRAWER_MIN_WIDTH = 10;
export const DRAWER_MAX_WIDTH = 1250;
export const DRAWER_CLOSING_WIDTH = 280;

export const BOTTOM_DRAWER_DEFAULT_HEIGHT = 330;
export const BOTTOM_DRAWER_MIN_HEIGHT = 10;
export const BOTTOM_DRAWER_MAX_HEIGHT = 750;
export const BOTTOM_DRAWER_CLOSING_HEIGHT = 150;

export const SCENARIO_SELECTOR_DEFAULT_HEIGHT = 210;
export const SCENARIO_SELECTOR_MIN_HEIGHT = 125;
export const SCENARIO_SELECTOR_MAX_HEIGHT = 800;

export const PROCESS_LOG_DEFAULT_HEIGHT = 78;
export const PROCESS_LOG_EXPANDED_HEIGHT = 360;

// Feature Codenames
export const PYLON_LOCATING = "pylon_locating";
export const PATH_TECHNOLOGIES = "path_technologies";
export const SITING_KPI_EXPLORER = "siting_kpi_explorer";

// Comments
export const threadColors = [
  "#00BEF3",
  "#4CD964",
  "#FFCC00",
  "#FF2D55",
  "#CBD2E1",
  "#437DF9"
];

// EDITOR MODES
export const EDITOR_MODES = {
  NO_EDITOR: 0,
  PROJECT_POINTS_EDITOR: 1,
  SCENARIO_POINTS_EDITOR: 2
};

export const POINT_TOOLS = {
  START_POINT: "StartPoint",
  END_POINT: "EndPoint",
  INTERMEDIATE: "Intermediate",
  CIRCLE_AREA: "Circle",
  SQUARE_AREA: "Square",
  POLGON_AREA: "Polygon",
  ELLIPSE_AREA: "Ellipse"
};

// Ellipse area tool parameter defaults and limits. Defaults follow the
// customer methodology (10% ingress/egress buffer, 25% circuity factor,
// see work item #4749). Circuity negative values would produce
// an invalid (NaN) geometry.
export const ELLIPSE_BUFFER = { default: 10, min: 0, max: 100 };
export const ELLIPSE_CIRCUITY = { default: 25, min: 1, max: 100 };

// PATH SECTIONS
export const PATH_EDIT_MODES = {
  SELECT_PATH: "selectPath",
  SELECT_SECTION: "selectSection",
  SELECT_TECHNOLOGY: "selectTechnology",
  SPLIT: "selectNodeSplit",
  JOIN: "selectNodeJoin"
};

// TOOLBOXES
export const MEASUREMENT_2D_TOOLS = "measurements_2d_tools";
export const PYLONS_2D_TOOLS = "pylons_2d_tools";
export const MEASUREMENT_3D_TOOLS = "measurements_3d_tools";
export const PYLONS_3D_TOOLS = "pylons_3d_tools";

export const PATH_TOOLS_2D = {
  INFO_PYLON: "2DInfoPylon",
  MOVE_PYLON: "2DMovePylon",
  ADD_PYLON: "2DAddPylon",
  DELETE_PYLON: "2DDeletePylon"
};
export const PYLON_TOOLS_2D = {
  EDIT_VARIANT: "2DEditVariant"
};

export const PATH_TOOLS_3D = {
  INFO_PYLON: "3DInfoPylon",
  MOVE_PYLON: "3DMovePylon",
  ADD_PYLON: "3DAddPylon",
  DELETE_PYLON: "3DDeletePylon",
  EDIT_VARIANT: "3DEditVariant"
};

export const CHANGE_PROJECT_STATE = {
  IDLE: "IDLE",
  FINISHED: "FINISHED",
  CHANGING: "CHANGING",
  FAILED: "FAILED"
};

export const CURRENCY_SYMBOLS = {
  USD: "$", // US Dollar
  EUR: "€", // Euro
  CRC: "₡", // Costa Rican Colón
  GBP: "£", // British Pound Sterling
  ILS: "₪", // Israeli New Sheqel
  INR: "₹", // Indian Rupee
  JPY: "¥", // Japanese Yen
  KRW: "₩", // South Korean Won
  NGN: "₦", // Nigerian Naira
  PHP: "₱", // Philippine Peso
  PLN: "zł", // Polish Zloty
  PYG: "₲", // Paraguayan Guarani
  THB: "฿", // Thai Baht
  UAH: "₴", // Ukrainian Hryvnia
  VND: "₫", // Vietnamese Dong
  CHF: "CHF" // Swiss francs
};

// Constants used by the SridSelector and other components
export const IMPORT_JSON_FALLBACK_DATA = [{ label: "WGS 84", value: 4326 }];
export const DEFAULT_FALLBACK_EPSG =
  IMPORT_JSON_FALLBACK_DATA[0].value.toString();

// Constants for the Cookie Tools
export const HOTJAR_SCRIPT_ID = "hotjar-script";

/**
 * @typedef {Object} CookieState
 * @property {string} UNKNOWN - Represents the state where the cookie consent is unknown.
 * @property {string} NECESSARY_ONLY - Represents the state where only necessary cookies are accepted.
 * @property {string} ACCEPTED_ALL - Represents the state where all cookies are accepted.
 */
export const CookieState = {
  UNKNOWN: "unknown",
  NECESSARY_ONLY: "necessary_only",
  ACCEPTED_ALL: "accepted_all"
};

export const COOKIE_CONSENT_KEY = "CookieConsent";
export const GOOGLE_ANALYTICS_ID_KEY = "REACT_APP_GOOGLE_ANALYTICS";

export const VALIDATION_MODE = {
  ALL: "all",
  COMMENTS_ONLY: "commentsonly",
  VALIDATIONS_ONLY: "validationsonly"
};

// CATENARY
export const DEFAULT_A_PARAM = 900;

// Profile Tabs
export const PROFILE_TABS = {
  PROJECTS: "projects",
  SCENARIOS: "scenarios",
  BASE_LAYERS: "baselayers",
  SECURITY: "security",
  PROFILE: "profile",
  TOKENS: "tokens",
  CATALOGS: "catalogs"
};

export const PROFILE_RAIL_SECTIONS = [
  {
    labelKey: "userProfile.DataManagement",
    tabs: [
      PROFILE_TABS.PROJECTS,
      PROFILE_TABS.SCENARIOS,
      PROFILE_TABS.BASE_LAYERS,
      PROFILE_TABS.CATALOGS
    ]
  },
  {
    labelKey: "userProfile.UserArea",
    tabs: [PROFILE_TABS.PROFILE, PROFILE_TABS.SECURITY, PROFILE_TABS.TOKENS]
  }
];

//Right menu tabs
export const RIGHT_MENU_RESULTS_TABS = {
  SCENARIO: "scenario",
  GEOPROCESSES: "geoprocesses"
};

export const SCENARIO_TYPE = {
  CLASSIC: "CLASSIC",
  MULTI: "MULTI",
  MULTI_CHILD: "MULTI",
  MULTI_CHILD_OH: "MULTI-CHILD-OH",
  MULTI_CHILD_OH_EC_TRAN: "MULTI-CHILD-OH-EC-TRAN",
  MULTI_CHILD_TUN: "MULTI-CHILD-TUN",
  MULTI_CHILD_TU_E: "MULTI-CHILD-TU-E",
  MULTI_CHILD_EC: "MULTI-CHILD-EC",
  SITING: "SITING"
};

export const KPI_FORMATS = {
  NUMBER: "NUMBER",
  COST: "COST",
  FREE: "FREE",
  XYPAIRS: "XYPAIRS",
  XYPAIRS_MDATA: "XYPAIRS_MDATA",
  HISTOGRAM: "HISTOGRAM",
  KVAL_NUM: "KVAL_NUM",
  KVAL_MDATA_W_VAL: "KVAL_MDATA_W_VAL",
  GEO_REF_TABLE: "GEO_REF_TABLE",
  TABLE: "TABLE"
};

export const MAX_VISIBLE_CHART_LAYERS = 25;

export const SITE_KPI_TYPE = {
  LAYER_INTERSECTIONS: "LAYER_INTERSECTIONS",
  TOTAL_LAYER_INTERSECTIONS: "TOTAL_LAYER_INTERSECTIONS",
  SITE_COVERAGE: "SITE_COVERAGE",
  ELEVATION_HISTOGRAM: "ELEVATION_HISTOGRAM",
  SLOPE_HISTOGRAM: "SLOPE_HISTOGRAM",
  SITE_LAYER_DISTANCES: "SITE_LAYER_DISTANCES"
};

// Configuration for each Site KPI type
export const SITE_KPI_CONFIG = {
  [SITE_KPI_TYPE.LAYER_INTERSECTIONS]: {
    kpiClass: "SiteIntersections",
    metricName: "INTERSECTIONS",
    label: "KpiLabels.LayerIntersections"
  },
  [SITE_KPI_TYPE.TOTAL_LAYER_INTERSECTIONS]: {
    kpiClass: "SiteIntersections",
    metricName: "TOTAL",
    label: "SiteCharts.TotalLayerIntersections"
  },
  [SITE_KPI_TYPE.SITE_COVERAGE]: {
    kpiClass: "SiteIntersections",
    metricName: "AREA",
    label: "KpiLabels.LayerCoverage"
  },
  [SITE_KPI_TYPE.SITE_LAYER_DISTANCES]: {
    kpiClass: "SiteLayerDistances",
    metricName: "DISTANCES",
    label: "KpiLabels.LayerDistances"
  },
  [SITE_KPI_TYPE.ELEVATION_HISTOGRAM]: {
    kpiClass: "ElevationHistogram",
    metricName: "default",
    label: "KpiLabels.ElevationHistogram",
    xAxisBaseLabel: "common.Elevation",
    xAxisFamily: "length"
  },
  [SITE_KPI_TYPE.SLOPE_HISTOGRAM]: {
    kpiClass: "SlopeHistogram",
    metricName: "default",
    label: "KpiLabels.SlopeHistogram",
    xAxisBaseLabel: "common.Slope"
  }
};

export const PATH_KPI_TYPE = {
  NG_CONSTRUCTION_COST: "NG_CONSTRUCTION_COST",
  NG_CONSTRUCTION_TIME: "NG_CONSTRUCTION_TIME",
  DUMMY_COST_MODEL: "DUMMY_COST_MODEL",
  DUMMY_TECH_COST: "DUMMY_TECH_COST",
  ECO_CO2: "ECO_CO2",
  ECO_UBP: "ECO_UBP",
  ECO_NO_REN_EN: "ECO_NO_REN_EN",
  ECO_REN_EN: "ECO_REN_EN",
  NG_ENV_IMPACT: "NG_ENV_IMPACT",
  GILYTICS_COST: "GILYTICS_COST",
  GENERIC_IMPACT: "GENERIC_IMPACT",
  SECTION_LENGTH_COST: "SECTION_LENGTH_COST",
  SECTION_LENGTH_3D: "SECTION_LENGTH_3D",
  TECH_SECTIONS_COST: "TECH_SECTIONS_COST",
  LAYER_AND_CATEGORY_COVERAGE: "LAYER_AND_CATEGORY_COVERAGE",
  PIPES_COST: "PIPES_COST",
  RESISTANCE_COST: "RESISTANCE_COST",
  RESISTANCE_PROFILE: "RESISTANCE_PROFILE",
  NG_SOCIO_IMPACT: "NG_SOCIO_IMPACT",
  NG_TECH_IMPACT: "NG_TECH_IMPACT",
  TECH_SIMPLE_COST: "TECH_SIMPLE_COST",
  TERNA_COST: "TERNA_COST",
  TERRAIN_PROFILE: "TERRAIN_PROFILE",
  HEIGHT_VARIATION: "HEIGHT_VARIATION",
  HEIGHT_DIFFERENCE: "HEIGHT_DIFFERENCE",
  PATH_COVERAGE: "PATH_COVERAGE"
};

// Configuration for each Path KPI type
export const PATH_KPI_CONFIG = {
  [PATH_KPI_TYPE.TERRAIN_PROFILE]: {
    kpiClass: "TerrainProfile",
    metricName: "TERRAIN_PROFILE",
    label: "KpiLabels.ElevationProfile",
    xAxisLabel: "PathCharts.ElevationWithUnit"
  },
  [PATH_KPI_TYPE.RESISTANCE_PROFILE]: {
    kpiClass: "ResistanceProfile",
    metricName: "RESISTANCE_PROFILE",
    label: "KpiLabels.ResistanceProfile",
    xAxisLabel: "PathCharts.ResistanceWithUnit"
  },
  [PATH_KPI_TYPE.HEIGHT_VARIATION]: {
    kpiClass: "TerrainProfile",
    metricName: "HEIGHT_VARIATION",
    label: "PathKpiTypes.HeightVariation"
  },
  [PATH_KPI_TYPE.HEIGHT_DIFFERENCE]: {
    kpiClass: "TerrainProfile",
    metricName: "HEIGHT_DIFFERENCE",
    label: "PathKpiTypes.HeightDifference"
  },
  [PATH_KPI_TYPE.PATH_COVERAGE]: {
    kpiClass: "LayerAndCategoryCoverage",
    metricName: "LAYER_COVER",
    label: "KpiLabels.LayerCoverage"
  }
};

// Used in the useKpiExplorerto identify the "Cost" KPI
// among the number KPIs of a path.
export const KPI_EXPLORER_CANONICAL_NUMBER_NAME = "COST_TOTAL";

// Palette types
export const PALETTE_TYPES = {
  LINEAR: "LINEAR",
  ABSOLUTE: "0_AT_128"
};

// Coloring modes for Resistance Map visualization
export const COLORING_MODES = {
  LINEAR: "LINEAR",
  COLOR_CLASSIFICATION: "COLOR_CLASSIFICATION"
};

// Default palette name for Resistance Map visualization
export const DEFAULT_PALETTE_NAME = "RM_YBR";

// Results modes
export const RESULTS_MODES = {
  ALL: "all",
  SCENARIO: "scenario"
};

// BaseLayer editing toolbox: feature-level tools
export const BASE_LAYER_FEATURE_TOOLS = {
  ADD: "add",
  EDIT: "edit",
  DELETE: "delete",
  INFO: "info",
  UNDO: "undo"
};

// BaseLayer editing toolbox: vertex-level tools (shown while a feature is being edited)
export const BASE_LAYER_VERTEX_TOOLS = {
  ADD: "add",
  MOVE: "move",
  DELETE: "delete"
};
